import DownloadOva from '@bumble/app/components/DownloadOva';
import GenerateCloudData from '@bumble/app/components/GenerateCloudData';
import HardwareDevice from '@bumble/app/components/HardwareDevice';
import HostedNode from '@bumble/app/components/HostedNode';
import {
  Box,
  Tab,
  Tabs,
} from '@mui/material';
import { SyntheticEvent, useState } from 'react';

type FormFactor = 'download' | 'hardware' | 'aws' | 'hosted';

interface ManageFormFactorProps {
  type: 'endpoint' | 'service';
  selectedNode: string;
  onClose: () => void;
}
const ManageFormFactor = ({ type, selectedNode, onClose }: ManageFormFactorProps) => {

  const [selectedFormFactor, setSelectedFormFactor] = useState<FormFactor>('download');

  const handleChange = (e: SyntheticEvent, val: FormFactor) => {
    setSelectedFormFactor(val);
  };

  return (
    <Box>
      <Tabs value={selectedFormFactor} onChange={handleChange} sx={{ mb: 5 }} centered>
        <Tab label="Download OVA" value="download" />
        <Tab label="Hardware Device" value="hardware" />
        <Tab label="AWS AMI" value="aws" />
        <Tab label="Hosted Node" value="hosted" />
      </Tabs>
      {selectedFormFactor === 'download' && selectedNode !== '' && (
        <DownloadOva
          node={selectedNode}
          type={type}
          onClose={onClose}
        />
      )}
      {selectedFormFactor === 'hardware' && selectedNode !== '' && (
        <HardwareDevice
          node={selectedNode}
          type={type}
          onClose={onClose}
        />
      )}
      {selectedFormFactor === 'aws' && selectedNode !== '' && (
        <GenerateCloudData
          node={selectedNode}
          type={type}
          onClose={onClose}
        />
      )}
      {selectedFormFactor === 'hosted' && selectedNode !== '' && (
        <HostedNode
          node={selectedNode}
          type={type}
          onClose={onClose}
        />
      )}
    </Box>
  );
};

export default ManageFormFactor;